/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryName");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryName.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryName>): AwsSsmDocumentQueryName {
        let obj = Object.assign(new AwsSsmDocumentQueryName(), model);
        AwsSsmDocumentQueryName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryName>): AwsSsmDocumentQueryName {
        if (!model) return null;
        return AwsSsmDocumentQueryName.newInstance(<AwsSsmDocumentQueryName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryName) {
        if (!obj) return;

        models.AwsSsmDocumentQueryName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Name of the Automation/Command document
     */
    document_names: Array<string>;

}
